const TOAST_EVENT = "nema:toast";

/** Suppress duplicate same-type + same-message within this window (e.g. React Strict Mode double effects). */
const DEDUP_MS = 750;
let lastDedupeKey = "";
let lastDedupeAt = 0;

export function showToast({ type = "info", message = "", duration = 3200 } = {}) {
  if (!message || typeof window === "undefined") return;
  const key = `${type}:${message}`;
  const now = Date.now();
  if (key === lastDedupeKey && now - lastDedupeAt < DEDUP_MS) return;
  lastDedupeKey = key;
  lastDedupeAt = now;
  window.dispatchEvent(
    new CustomEvent(TOAST_EVENT, {
      detail: {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        type,
        message,
        duration,
      },
    })
  );
}

showToast.success = (message, duration) => showToast({ type: "success", message, duration });
showToast.error = (message, duration) => showToast({ type: "error", message, duration });
showToast.info = (message, duration) => showToast({ type: "info", message, duration });

export { TOAST_EVENT };
